import { useRef } from 'react';
import { ACTIVITY_TYPES } from '../../../constants/activities.constants';
import ActivityItemBlock from './ActivityItemBlock';

const DossierSidebarActivity = ({ items }) => {
  const wrapperRef = useRef(null);

  const mapActivitiesWithBlocks = () => {
    const allBlocks = [];
    const statusBlockIndexes = [];
    items?.forEach((i, index) => {
      allBlocks.push(i);
      if (i.type === ACTIVITY_TYPES.STATUS) {
        statusBlockIndexes.push(index);
      }
    });
    return statusBlockIndexes.map((sbi, index) => {
      const isLast = statusBlockIndexes.length - 1 === index;
      const currentStatusBlocks = allBlocks.slice(sbi, statusBlockIndexes[index + 1]);
      return <ActivityItemBlock key={index} isLast={isLast} activities={currentStatusBlocks} />;
    });
  };

  return (
    <div ref={wrapperRef} id="js-spo-dossier-sidebar-activity" className="spo-m-dossier-sidebar-activity">
      {mapActivitiesWithBlocks()}
    </div>
  );
};

export default DossierSidebarActivity;
